export const addListener = (e, t) => window.addEventListener(e, t)
export const removeListener = (e, t) => window.removeEventListener(e, t)
